import IndoorMapView from "./src/Main";

declare global {
    export type woosmapIndoorWidget = IndoorMapView;
    export const woosmapIndoorWidget: typeof IndoorMapView;

    interface Window {
        woosmapIndoor: IndoorMapView;
        dataLayer: Array<{ [key: string]: any }>;
    }
}

(window as any).woosmapIndoorWidget = IndoorMapView;

